import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { usePrefix } from '../ConfigProvider';
import Tooltip from '../Tooltip';
import { concat } from '../utils';
import Inner from './Inner';
export default function Popover(props) {
    var title = props.title, content = props.content, icon = props.icon, prefixCls = props.prefixCls, buttons = props.buttons, _a = props.defaultVisible, defaultVisible = _a === void 0 ? false : _a, onVisibleChange = props.onVisibleChange, rest = __rest(props, ["title", "content", "icon", "prefixCls", "buttons", "defaultVisible", "onVisibleChange"]);
    var _b = useState(defaultVisible), tooltipVisible = _b[0], setTooltipVisible = _b[1];
    var prefix = usePrefix('popover', prefixCls);
    var innerPrefix = concat(prefix, 'inner');
    function onTooltipVisibleChange(value) {
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(value);
        setTooltipVisible(value);
    }
    return (React.createElement(Tooltip, __assign({ title: React.createElement(Inner, { title: title, icon: icon, content: content, prefix: innerPrefix, buttons: buttons, close: function () { return setTooltipVisible(false); } }), prefixCls: prefix, visible: tooltipVisible, onVisibleChange: onTooltipVisibleChange }, rest)));
}
//# sourceMappingURL=index.js.map